import Question from '../../../interfaces/question';
import { ChosenOptionAnswer } from '../../context/SurveyPageContext';
import { DropdownOption } from '../Dropdown/Dropdown';

const questionToDropdownOptions = (
  question: Question,
  selectedOption?: ChosenOptionAnswer,
): DropdownOption[] => [
  ...question.radioButtonOptions
    .sort((a, b) => a?.position - b?.position)
    .map((c) => ({
      value: c.id.toString(10) || '',
      label: c.description || '',
      isSelected: !!(selectedOption && c.id === selectedOption.chosenOption?.id),
    })),
];

export { questionToDropdownOptions };
